import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { SiteContentProvider } from "@/context/SiteContentContext";
import { LanguageProvider } from "@/i18n";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Artists from "@/pages/Artists";
import ArtistDetail from "@/pages/ArtistDetail";
import Events from "@/pages/Events";
import Shop from "@/pages/Shop";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ShopifyEmbed from "@/pages/ShopifyEmbed";
import Lab from "@/pages/Lab";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { MemberLogin, MemberLayout, MemberStatement, MemberFinanzas, MemberProyectos } from "@/pages/Member";
import InvitePage from "@/pages/InvitePage";
import Register, { RegisterSuccess } from "@/pages/Register";
import AfterDark from "@/pages/AfterDark";
import ProductDetail from "@/pages/ProductDetail";

export default function App() {
    return (
        <LanguageProvider>
            <SiteContentProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route element={<Layout />}>
                                <Route path="/" element={<Home />} />
                                <Route path="/artists" element={<Artists />} />
                                <Route path="/artists/:slug" element={<ArtistDetail />} />
                                <Route path="/events" element={<Events />} />
                                <Route path="/shop" element={<Shop />} />
                                <Route path="/shop/:id" element={<ProductDetail />} />
                                <Route path="/studio" element={<About />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/embed" element={<ShopifyEmbed />} />
                                {/* After Dark now lives INSIDE Layout so the
                                    navbar + footer are visible (users need to
                                    navigate back to the rest of the site). */}
                                <Route path="/after-dark" element={<AfterDark />} />
                                <Route path="/lab" element={<Lab />} />
                                <Route path="/admin" element={<AdminLogin />} />
                                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                                <Route path="/invite/:token" element={<InvitePage />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/register/success" element={<RegisterSuccess />} />
                                <Route path="/member/login" element={<MemberLogin />} />
                                <Route element={<MemberLayout />}>
                                    <Route path="/member" element={<MemberStatement />} />
                                    <Route path="/member/statement" element={<MemberStatement />} />
                                    <Route path="/member/finanzas" element={<MemberFinanzas />} />
                                    <Route path="/member/proyectos" element={<MemberProyectos />} />
                                </Route>
                            </Route>
                        </Routes>
                    </BrowserRouter>
                </AuthProvider>
            </SiteContentProvider>
        </LanguageProvider>
    );
}
